<script>
import {defineComponent} from 'vue'
import VueGoogleAutocomplete from "vue-google-autocomplete";
import {mapState} from "vuex";
import i18n from "@/i18n";

export default defineComponent({
  name: "Establishment",
  props: {
    isThirdAccount: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      unset_establishment: {
        // blank establishment sent on save document
        id: 0,
        contacts: null,
        details: null,
        emails: null,
        is_favorite: null,
        is_headquarter: 0,
        name: null,
        nic: null,
        phones: null,
        place: null
      },
    }
  },
  computed: {
    ...mapState({
      appId: state => state.app.id,
      rights: state => state.app.rights,
    }),
    contactInfos: {
      get() {
        return this.isThirdAccount ? this.$store.state.contacts.thirdAccount : this.$store.state.contacts.contactInfos;
      },
      set(value) {
        this.isThirdAccount ? this.$store.commit("thirdAccount", value) : this.$store.commit("contactInfos", value);
      }
    },
    selectedEstablishment: {
      get: function() {
        // getter is based on contactInfos.establishment_id
        let _by_id = undefined;
        let _by_address = undefined;
        let _by_headquarters = undefined;

        if (!this.contactInfos.establishments?.length) return this.unset_establishment;

        // user created a new establishment
        if (this.contactInfos.establishment_id === 0) return this.unset_establishment;

        // user did select an existing establishment
        if (this.contactInfos.establishment_id) {
          _by_id = this.contactInfos.establishments.find(
              e => e.id === this.contactInfos.establishment_id
          );
          if (_by_id !== undefined) {
            return _by_id;
          }
        }

        // on load, if no loaded document
        _by_headquarters = this.contactInfos.establishments.find(e => e.is_headquarters === 1);
        if (_by_headquarters !== undefined) {
          if (_by_headquarters.details?.length) {
            this.$store.commit("details", _by_headquarters.details);
          }
          return _by_headquarters;
        }

        _by_address = this.contactInfos.establishments.find(
            (e) => {
              if (!e.place?.formatted_address?.length) return false;

              const _formatted_address = e.place.formatted_address.replaceAll(/[-\s]/g, "");
              return _formatted_address.includes(this.contactInfos.address.replaceAll(/[-\s]/g, "")) &&
                  _formatted_address.includes(this.contactInfos.location.replaceAll(/[-\s]/g, ""));
            }
        );
        if (_by_address !== undefined) {
          return _by_address;
        }
        // default first establishment
        //if(this.contactInfos.establishments[0]?.details?.length) {
        //  this.$store.commit("details", this.contactInfos.establishments[0].details);
        //}
        return this.contactInfos.establishments[0] ?? null;
      },
      set(newEstablishment) {
        console.log("new selectedEstablishment", newEstablishment);
        // update contact_info properties
        const _contactInfos = JSON.parse(JSON.stringify(this.contactInfos));
        _contactInfos.address = newEstablishment.place
            ? newEstablishment.place.exported_address.trim()
            : "";
        _contactInfos.location = newEstablishment.place
            ? (
                (newEstablishment.place.postal_code ?? "") +
                " " +
                (newEstablishment.place.locality ?? "") +
                " " +
                (newEstablishment.place.country ?? "")
            ).trim()
            : "";
        _contactInfos.establishment_id = newEstablishment.id;

        this.contactInfos = Object.assign({}, { ..._contactInfos });
      }
    },
    isThirdAccountGlobal: {
      get() {
        return this.$store.state.contacts.isThirdAccountGlobal;
      },
      set(value) {
        this.$store.commit("isThirdAccountGlobal", value);
      }
    },
  },
  watch: {
    contactInfos: {
      handler(oldVal, newVal) {
        //if (oldVal?.id === newVal?.id )
          this.handleContactInfosChange();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleContactInfosChange() {
      // add "no address if no establishment for a contactInfos"
      if (this.contactInfos.address === undefined || this.contactInfos.address === null)
        this.contactInfos.address = "";
      if (this.contactInfos.location === undefined || this.contactInfos.location === null)
        this.contactInfos.location = "";
      if (this.contactInfos_formated_address === undefined || this.contactInfos_formated_address === null)
        this.contactInfos_formated_address = "";

    },
    showModalEditEstablishment(establishment) {
      this.isThirdAccountGlobal = this.isThirdAccount;
      // local contact management
      if (this.eventContact !== true) {
        this.$store.commit("editableEstablishment", establishment);
        this.$store.commit("showEditAddressModal", true);
        this.$store.commit("renderGA", true);
      } else { // app contact management
        this.dispatchEvent({
          modalName: null,
          source: "billing",
          action: "edit_establishment",
          data: { establishment }
        });
      }
    },
    constructAddress(place) {
      if (!place) return "";
      const { street_number, route, route2 } = place;
      var line = [street_number ?? "", route ?? "", route2 ? `- ${route2}` : ""];
      return line
          .filter(n => n)
          .join(" ")
          .trim();
    },
    constructLocation(place) {
      if (!place) return "";
      const { postal_code, locality, country } = place;
      var line = [postal_code ?? "", locality ?? "", country ? `- ${country}` : ""];
      return line
          .filter(n => n)
          .join(" ")
          .trim();
    },
    constructFormattedAdress(place) {
      if (!place || !place.formatted_address.length)
        return `<span class="no-contact-data">${i18n.t('Aucune adresse')}</span>`;

      return this.constructAddress(place) + "<br>" + this.constructLocation(place);
    },
    onEstablishmentChange(establishment) {
      // call when user select an establishment
      this.selectedEstablishment = establishment;
    },
    addBlankEstablishment() {
      this.selectedEstablishment = this.unset_establishment;
      this.showModalEditEstablishment(this.unset_establishment);
    },
    isEmptyAddress() {
      const p = this.selectedEstablishment?.place;
      return (
          this.selectedEstablishment?.id === 0 ||
          (!p?.locality?.length && !p?.postal_code && !p?.exported_address?.length)
      );
    },
  }
})
</script>

<template>
  <b-container class="mb-2">
    <b-row>
      <b-col
          v-if="isEmptyAddress(selectedEstablishment)"
          cols="9"
      >
        <!-- Establishment creation mode -->
        <div
            v-if="((rights?.includes('!app.contacts.create') ? false : true) ?? true)"
            class="btn-link"
            style="cursor: pointer; min-height: 2.5rem"
            @click="showModalEditEstablishment(selectedEstablishment)"
        >
          <div>
            {{ $t("Aucune adresse renseignée") }}
          </div>
        </div>
        <!-- plan has no rights on establishment -->
        <div
            v-else
            class="text-muted italic"
        >
          {{ $t("Aucune adresse renseignée") }}
        </div>
      </b-col>
      <b-col cols="9" v-else style="min-height: 40px">
        <!-- Establishment selection mode -->
        <div>
          {{ constructAddress(selectedEstablishment.place) }}
        </div>
        <div>
          <span>{{ constructLocation(selectedEstablishment.place) }}</span>
        </div>
      </b-col>
      <b-col
          v-if="(rights?.includes('!app.contacts.create') ? false : true) ?? true"
          cols="3"
          class="p-0 mt-0"
      >
        <!-- select Establishment -->
        <b-dropdown
            :id="'address' + (isThirdAccount ? '_third' : '')"
            size="xs"
            :text="$t('Adresse')"
            class="mt-0"
            variant="light"
            style="border: 1px solid var(--border); border-radius: 5px; min-width: 70px"
        >
          <b-dropdown-item
              v-for="(establishment, index) in contactInfos.establishments"
              :key="`e_${establishment.id}`"
          >
            <b-row>
              <b-col cols="11" @click="onEstablishmentChange(establishment)">
                <div class="establishment-details text-gray">
                  {{
                    establishment.name
                        ? establishment.name
                        : $t("établissement n°{index}", { index: (index + 1) })
                  }}
                </div>
                <div
                    class="establishment-details"
                    v-html="constructFormattedAdress(establishment.place)"
                />
              </b-col>
              <b-col cols="1" class="p-0 m-0">
                <b-icon
                    @click="showModalEditEstablishment(establishment)"
                    icon="pencil"
                    style="height: 17px; width: 17px;"
                />
              </b-col>
            </b-row>
          </b-dropdown-item>

          <!-- item gérér les établissements -->
          <b-dropdown-item class="text-center">
            <b-button
                variant="link"
                class="establishment-details"
                @click="addBlankEstablishment"
            >
              {{ $t("Ajouter un établissement") }}
            </b-button>
          </b-dropdown-item>
        </b-dropdown>
        <b-tooltip placement="top" :target="'address' + (isThirdAccount ? '_third' : '')" container="body">
          {{ $t("Adresse") }}
        </b-tooltip>
      </b-col>
    </b-row>
  </b-container>
</template>
